import React, { useEffect, useState } from 'react';
import { useSEO } from '../hooks/useSEO';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Heart, Gift, Target, Calendar, CircleDollarSign } from 'lucide-react';
import PageHero from '../components/PageHero';
import { DONATION_TYPES } from '../data/mock';
import { api } from '../lib/api';
import { EditRegion } from '../components/AdminEditBar';

const ICONS = { genel: CircleDollarSign, ozelgun: Gift, proje: Target, devre: Calendar, egitim: Heart };

const parseAmounts = (a) => {
  if (Array.isArray(a)) return a;
  if (typeof a === 'string') return a.split(',').map(s => parseInt(s.trim(), 10)).filter(n => !isNaN(n));
  return [];
};

export default function DonationTypes() {
  useSEO('donation_types');
  const [items, setItems] = useState(DONATION_TYPES);

  useEffect(() => {
    api.publicContent('donation_types').then(list => {
      const arr = (list || []).map(it => ({
        id: it.id, ...(it.data || {}),
        amounts: parseAmounts(it.data?.amounts),
      }));
      if (arr.length > 0) setItems(arr);
    }).catch(() => {});
  }, []);

  return (
    <EditRegion label="Bağış Türleri" to="/admin/donation-types">
      <>
      <PageHero slug="donation_types"
        kicker="Bağışlar"
        title={<>Bağış <span className="italic text-coral-200">türlerimiz</span>.</>}
        text="YEKÜV ailesi olarak bağışlarınızı farklı amaçlarla kullanıyoruz. İhtiyacınıza göre size uygun bağış türünü seçin."
      />

      <section className="bg-cream">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 md:py-28">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="donation-types-grid">
            {items.map((t, i) => {
              return (
                <EditRegion key={t.id || i} label="Bu Bağış Türünü Düzenle" to="/admin/donation-types">
                  <div className="group relative rounded-3xl overflow-hidden border transition-all bg-white border-ink-100 hover:border-gold flex flex-col" data-testid={`donation-type-${t.id || i}`}>
                    <div className="relative aspect-[4/3] overflow-hidden">
                      {t.image && <img src={t.image} alt={t.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />}
                      <div className="absolute inset-0 bg-gradient-to-t from-ink-900/60 via-transparent to-transparent" />
                    </div>
                    <div className="p-7 md:p-8 flex flex-col flex-1">
                      <h3 className="font-display leading-tight text-2xl md:text-[28px]">{t.title}</h3>
                      <p className="mt-3 text-sm md:text-base leading-relaxed text-ink-500">{t.description}</p>
                      {t.amounts && t.amounts.length > 0 && (
                        <div className="mt-5 flex flex-wrap gap-2">
                          {t.amounts.map(a => (
                            <span key={a} className="text-xs px-3 py-1.5 rounded-full tabular bg-cream-200 text-ink-500">₺{a.toLocaleString('tr-TR')}</span>
                          ))}
                        </div>
                      )}
                      <Link to={t.link || '/bagis'} className="mt-auto pt-7 inline-flex items-center gap-2 text-sm font-semibold">
                        <span className="inline-flex items-center gap-2 rounded-full px-5 h-11 bg-ink-600 text-cream hover:bg-ink-500 transition-colors">
                          {t.cta || 'Bağış Yap'} <ArrowUpRight className="w-4 h-4" />
                        </span>
                      </Link>
                    </div>
                  </div>
                </EditRegion>
              );
            })}
          </div>
        </div>
      </section>
    </>
    </EditRegion>
  );
}
